import jsonFetch from '../utilities/jsonFetch.js';
import getAppRoot from '../utilities/getAppRoot.js';


export default ({
  token,
}) =>  ({
  checkEmail: async (emailAddress, captcha) => {
    try {
      return await jsonFetch({
        body: {
          emailAddress
        },
        headers: {
          'RequestVerificationToken': token,
          'X-Captcha-Token': captcha
        },
        method: 'POST',
        url: `/${getAppRoot()}/recover/password/webmail`
      });
    } catch (error) {
      if (error.httpCode === 404) {
        return null;
      }

      throw error;
    }
  },
  confirmEmailAndPhoneNumber: async (emailAddress, phoneNumber) => {
    return await jsonFetch({
      body: {
        emailAddress,
        phoneNumber,
      },
      headers: {
        'RequestVerificationToken': token,
      },
      method: 'POST',
      url: `/${getAppRoot()}/recover/password/webmail/confirmPhone`
    });
  },

  resetPassword: async ({
    authorizationToken,
    password,
  }) => {
    return await jsonFetch({
      body: {
        password,
        token: authorizationToken,
      },
      headers: {
        'RequestVerificationToken': token,
      },
      method: 'POST',
      url: `/${getAppRoot()}/recover/password/webmail/reset`
    });
  },

  verifyChallenge: async ({
    emailAddress,
    schemeUid,
    verificationCode,
  }) => {
    return await jsonFetch({
      body: {
        emailAddress,
        schemeUid,
        verificationCode,
      },
      headers: {
        'RequestVerificationToken': token,
      },
      method: 'POST',
      url: `/${getAppRoot()}/recover/password/webmail/verifyChallenge`
    });
  }
});
